import { motion } from 'framer-motion';
import styled from 'styled-components';

interface CoordProps {
    $left?: number;
    $top?: number;
}

export const COL_PEEK_DIMENSIONS = {
    height: 230,
    width: 570,
};

export const DesktopWrapper = styled(motion.div)<CoordProps>`
    overflow-x: auto;
    position: absolute;
    max-width: ${COL_PEEK_DIMENSIONS.width}px;
    height: ${COL_PEEK_DIMENSIONS.height}px;
    left: ${({ $left }) => $left}px;
    top: ${({ $top }) => $top}px;

    background: #1a2025;
    box-shadow: 0 14px 40px rgba(0, 0, 0, 0.5);
    border-radius: 16px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15px;
    z-index: 1000;
`;
